'use client'

import { usePathname } from 'next/navigation'
import { useTranslations } from 'next-intl'

import { useTaskReturn } from '@/hooks/use-list-return'
import { taskPageOf, type ReturnLabel } from '@/lib/navigation/task-pages'

/**
 * The words of "‹ …" on a task page (ALU-4): the page it returns to, which
 * is the page the member came from ("‹ Inicio" after "Pedir mentoría" on the
 * Home, "‹ Tu perfil" from an editor), or the task's fallback on a cold entry.
 */
export function useTaskBackLabel(label: ReturnLabel | null): string | null {
  const t = useTranslations('encuentro.frame')
  const otherProfile = taskPageOf(usePathname() ?? '')?.otherProfile === true
  if (!label) return null
  // The mutual list (ALU-241) returns to someone else's profile, not "Tu perfil".
  if (label.kind === 'profile') return t(otherProfile ? 'returnTo.otherProfile' : 'returnTo.profile')
  if (label.kind === 'job') return t('returnTo.job')
  return t(`destination.${label.destination}`)
}

/** `useTaskReturn` plus its label, for the back controls of the frame and the page header. */
export function useTaskBack() {
  const task = useTaskReturn()
  return { ...task, text: useTaskBackLabel(task.label) }
}
